import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { AxiosError } from 'axios';
import { classToPlain, plainToClass } from 'class-transformer';
import { API_PATH } from '../models/Constants';
import { ClosureContract } from '../models/Contract';
import { BestPractices, Disclaimer, FinancialOverviewM6P1Row, FinancialOverviewResponse, FinancialOverviewResponseM6P1, FinancialOverviewRow, KeyIndicatorsM4P1, KeyIndicatorsM4P3Road, KeyIndicatorsM4P3Water, KeyIndicatorsM4P4, KeyIndicatorsM6P1, ProjectImplementation } from '../models/PCR';
// import { sample } from "lodash"

export default class PCRApi {
    private http: HTTPClient;
    private static instance: PCRApi | null = null;

    private constructor(http: HTTPClient) {
        this.http = http;
    }

    public static getInstance(http: HTTPClient): PCRApi {
        if (this.instance) {
            return this.instance;
        }
        this.instance = new PCRApi(http);
        return this.instance;
    }

    async getClosureContract(subjectId: string, contractId: string, applicationId: string): Promise<[ClosureContract | null, AxiosError | null]> {
        return new Promise((resolve) => {
            // const dataMock = plainToClass(ClosureContract, {
            //     "subject_id": 954080,
            //     "application_id": 220029,
            //     "contract_id": 19212,
            //     "project_app_id": 220029,
            //     "contract_code": "19212/190726/2017",
            //     "identification_code": "19212/190726/2017",
            //     "description": null,
            //     "project_title": "PARTICIPATION IN THE RURAL DEVELOPMENT COMMITTEE MEETING TO BE HELD ON THE 14TH OF JUNE 2017 ",
            //     "status": "WITHDRAWN",
            //     "cod_modu": "M04.1", //  "M04.1" or "M04.3" or "M04.4" or "M06.1"
            //     "type_modu": "water",
            //     "measure": "CHANGE REQUEST APPLICATION",
            //     "proj_dt_end": 1653914252674,
            //     "total_proj_cost": 1653914252674,
            //     "can_edit": 1,
            //     "dt_grant_agreement": 3.14,
            //     "grant_amount": 3.14,
            //     "proj_duration": 3.14,
            //     "proj_focus_target_area": "proj_focus_target_area",
            //     "size_ha": 3.14,
            //     "paths": {
            //         "best-practices": 1,
            //         "disclaimer": 1,
            //         "financial-overview": 1,
            //         "financial-overview-m6-p1": 1,
            //         "key-indicators-m4-p1": 1,
            //         "key-indicators-m4-p3-roads": 1,
            //         "key-indicators-m4-p3-water": 1,
            //         "key-indicators-m4-p4": 1,
            //         "key-indicators-m6-p1": 1,
            //         "project-implementation": 1,
            //     }
            // });
            // resolve([dataMock, null]);

            this.http.get<ClosureContract>(`${API_PATH}/closure/contract/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(ClosureContract, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    async setClosureContract(subjectId: string, contractId: string, applicationId: string): Promise<[boolean | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<boolean>(`${API_PATH}/closure/submit/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([resp.data, null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getClosureFinancialOverview(subjectId: string, contractId: string, applicationId: string): Promise<[FinancialOverviewResponse | null, AxiosError | null]> {
        return new Promise((resolve) => {
            // const dataMock = plainToClass(FinancialOverviewResponse, {
            //     rows: [{
            //         actual_expenditure: 3.14,
            //         cost_budgeted: 3.14,
            //         cost_expenditure: 3.14,
            //         id_line_item: 3.14,
            //         type_description: "description",
            //         upload_urls: [],
            //         file_ids: [],
            //     }],
            //     totals: {}
            // });
            // resolve([dataMock, null]);

            this.http.get<FinancialOverviewResponse>(`${API_PATH}/closure/financial-overview/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(FinancialOverviewResponse, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setClosureFinancialOverview(subjectId: string, contractId: string, applicationId: string, data: FinancialOverviewRow[]): Promise<[FinancialOverviewResponse | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<FinancialOverviewResponse>(`${API_PATH}/closure/financial-overview/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(FinancialOverviewResponse, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getClosureFinancialOverviewM6P1(subjectId: string, contractId: string, applicationId: string): Promise<[FinancialOverviewResponseM6P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            // const dataMock = plainToClass(FinancialOverviewResponseM6P1, {
            //     rows: [{
            //         actual_expenditure: 3.14,
            //         cost_budgeted: 3.14,
            //         cost_expenditure: 3.14,
            //         id_line_item: 3.14,
            //         type_description: "description",
            //         upload_urls: [],
            //         file_ids: [],
            //     }],
            //     totals: {}
            // });
            // resolve([dataMock, null]);

            this.http.get<FinancialOverviewResponseM6P1>(`${API_PATH}/closure/financial-overview-m6-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(FinancialOverviewResponseM6P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setClosureFinancialOverviewM6P1(subjectId: string, contractId: string, applicationId: string, data: FinancialOverviewM6P1Row[]): Promise<[FinancialOverviewResponseM6P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<FinancialOverviewResponseM6P1>(`${API_PATH}/closure/financial-overview-m6-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(FinancialOverviewResponseM6P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getClosureDisclaimer(subjectId: string, contractId: string, applicationId: string): Promise<[Disclaimer | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<Disclaimer>(`${API_PATH}/closure/disclaimer/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(Disclaimer, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setClosureDisclaimer(subjectId: string, contractId: string, applicationId: string, data: Disclaimer): Promise<[Disclaimer | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<Disclaimer>(`${API_PATH}/closure/disclaimer/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(Disclaimer, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getClosureBestPractices(subjectId: string, contractId: string, applicationId: string): Promise<[BestPractices | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<BestPractices>(`${API_PATH}/closure/best-practices/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(BestPractices, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setClosureBestPractices(subjectId: string, contractId: string, applicationId: string, data: BestPractices): Promise<[BestPractices | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<BestPractices>(`${API_PATH}/closure/best-practices/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(BestPractices, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getClosureProjectImplementation(subjectId: string, contractId: string, applicationId: string): Promise<[ProjectImplementation | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<ProjectImplementation>(`${API_PATH}/closure/project-implementation/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(ProjectImplementation, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setClosureProjectImplementation(subjectId: string, contractId: string, applicationId: string, data: ProjectImplementation): Promise<[ProjectImplementation | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<ProjectImplementation>(`${API_PATH}/closure/project-implementation/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(ProjectImplementation, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getClosureKeyIndicatorsM4P1(subjectId: string, contractId: string, applicationId: string): Promise<[KeyIndicatorsM4P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<KeyIndicatorsM4P1>(`${API_PATH}/closure/key-indicators-m4-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(KeyIndicatorsM4P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setClosureKeyIndicatorsM4P1(subjectId: string, contractId: string, applicationId: string, data: KeyIndicatorsM4P1): Promise<[KeyIndicatorsM4P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<KeyIndicatorsM4P1>(`${API_PATH}/closure/key-indicators-m4-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(KeyIndicatorsM4P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getClosureKeyIndicatorsM4P3Water(subjectId: string, contractId: string, applicationId: string): Promise<[KeyIndicatorsM4P3Water | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<KeyIndicatorsM4P3Water>(`${API_PATH}/closure/key-indicators-m4-p3-water/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(KeyIndicatorsM4P3Water, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setClosureKeyIndicatorsM4P3Water(subjectId: string, contractId: string, applicationId: string, data: KeyIndicatorsM4P3Water): Promise<[KeyIndicatorsM4P3Water | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<KeyIndicatorsM4P3Water>(`${API_PATH}/closure/key-indicators-m4-p3-water/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(KeyIndicatorsM4P3Water, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getClosureKeyIndicatorsM4P3Roads(subjectId: string, contractId: string, applicationId: string): Promise<[KeyIndicatorsM4P3Road[] | null, AxiosError | null]> {
        return new Promise((resolve) => {
            // const fakeData = [
            //     {
            //         ds_road: "ds_road",
            //         fg_apply: "S",
            //         measurements: 3.14
            //     }
            // ];
            // resolve([plainToClass(KeyIndicatorsM4P3Road, fakeData), null]);

            this.http.get<KeyIndicatorsM4P3Road[]>(`${API_PATH}/closure/key-indicators-m4-p3-roads/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(KeyIndicatorsM4P3Road, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setClosureKeyIndicatorsM4P3Roads(subjectId: string, contractId: string, applicationId: string, data: KeyIndicatorsM4P3Road[]): Promise<[KeyIndicatorsM4P3Road[] | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<KeyIndicatorsM4P3Road[]>(`${API_PATH}/closure/key-indicators-m4-p3-roads/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(KeyIndicatorsM4P3Road, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getClosureKeyIndicatorsM4P4(subjectId: string, contractId: string, applicationId: string): Promise<[KeyIndicatorsM4P4 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<KeyIndicatorsM4P4>(`${API_PATH}/closure/key-indicators-m4-p4/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(KeyIndicatorsM4P4, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setClosureKeyIndicatorsM4P4(subjectId: string, contractId: string, applicationId: string, data: KeyIndicatorsM4P4): Promise<[KeyIndicatorsM4P4 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<KeyIndicatorsM4P4>(`${API_PATH}/closure/key-indicators-m4-p4/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(KeyIndicatorsM4P4, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }

    /**
     *
     * @param subjectId
     * @param contractId
     * @returns
     */
    async getClosureKeyIndicatorsM6P1(subjectId: string, contractId: string, applicationId: string): Promise<[KeyIndicatorsM6P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.get<KeyIndicatorsM6P1>(`${API_PATH}/closure/key-indicators-m6-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`)
                .then(resp => {
                    resolve([plainToClass(KeyIndicatorsM6P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
    async setClosureKeyIndicatorsM6P1(subjectId: string, contractId: string, applicationId: string, data: KeyIndicatorsM6P1): Promise<[KeyIndicatorsM6P1 | null, AxiosError | null]> {
        return new Promise((resolve) => {
            this.http.post<KeyIndicatorsM6P1>(`${API_PATH}/closure/key-indicators-m6-p1/${encodeURIComponent(subjectId)}/${encodeURIComponent(contractId)}/${encodeURIComponent(applicationId)}`, classToPlain(data))
                .then(resp => {
                    resolve([plainToClass(KeyIndicatorsM6P1, resp.data), null]);
                })
                .catch(err => {
                    resolve([null, err as AxiosError]);
                });
        });
    }
}
